import { h, inject, nextTick } from 'vue';
import { checkElementViewportFit } from '@/Utils';
import { ToggleInjectionKey } from './ToggleContainer';

export default {
    name: 'ToggleContent',
    emits: ['active-change'],
    props: {
        activeClass: { type: String, default: 'is-active' },
        tag: { type: String, default: 'div' },
        viewportOverflowLeftClass: { type: String },
        viewportOverflowRightClass: { type: String },
        viewportOverflowTopClass: { type: String },
        viewportOverflowBottomClass: { type: String },
        showExpanded: { type: Boolean, default: false },
        closeOnClick: { type: Boolean, default: false },
    },
    setup() {
        const toggle = inject(ToggleInjectionKey, null);

        return { toggle };
    },
    data() {
        return {
            overflowsViewportLeft: false,
            overflowsViewportRight: false,
            overflowsViewportTop: false,
            overflowsViewportBottom: false,
        };
    },
    computed: {
        isActive() {
            return this.toggle ? this.toggle.state.isActive : false;
        },
    },
    methods: {
        collapse() {
            this.toggle?.collapse();
        },
        expand() {
            this.toggle?.expand();
        },
        handleClick(event) {
            if (this.closeOnClick) {
                const firstChild = this.$el?.firstElementChild;

                if (firstChild && firstChild.contains(event.target) && event.target !== firstChild) {
                    this.collapse();
                }
            }
        },
        calculateViewportOverflow() {
            this.overflowsViewportLeft = false;
            this.overflowsViewportRight = false;
            this.overflowsViewportTop = false;
            this.overflowsViewportBottom = false;

            nextTick(() => {
                const fit = checkElementViewportFit(this.$el);

                this.overflowsViewportLeft = !fit.left;
                this.overflowsViewportRight = !fit.right;
                this.overflowsViewportTop = !fit.top;
                this.overflowsViewportBottom = !fit.bottom;
            });
        },
    },
    watch: {
        isActive(isActive) {
            if (isActive) {
                this.calculateViewportOverflow();
            }

            this.$emit('active-change', isActive);
        },
    },
    created() {
        if (this.showExpanded) {
            this.toggle?.expand();
        }
    },
    mounted() {
        this.toggle?.setContainerEl(this.$el);
    },
    beforeUnmount() {
        if (this.toggle?.state.containerEl === this.$el) {
            this.toggle.setContainerEl(null);
        }
    },
    render() {
        return h(this.tag, {
            class: {
                [this.activeClass]: this.isActive,
                [this.viewportOverflowLeftClass]: this.overflowsViewportLeft,
                [this.viewportOverflowRightClass]: this.overflowsViewportRight,
                [this.viewportOverflowTopClass]: this.overflowsViewportTop,
                [this.viewportOverflowBottomClass]: this.overflowsViewportBottom,
            },
            onClick: this.handleClick,
        }, this.$slots.default?.());
    },
};
